(() => {
  const SITE_REVEAL_SELECTOR = '[data-rotar-site-reveal]';
  const LEGACY_REVEAL_SELECTOR = '[data-rotar-reveal]';
  const visibleClass = 'is-visible';
  const main = document.querySelector('#MainContent');
  const isHomepage = main?.dataset.template === 'index';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const selector = isHomepage
    ? SITE_REVEAL_SELECTOR
    : `${SITE_REVEAL_SELECTOR}, ${LEGACY_REVEAL_SELECTOR}`;

  let observer;

  const show = (element) => element.classList.add(visibleClass);

  const prepare = (scope = document) => {
    const elements = [
      ...(scope.matches?.(selector) ? [scope] : []),
      ...scope.querySelectorAll(selector),
    ].filter((element) => !element.classList.contains(visibleClass));

    if (elements.length === 0) return;

    if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach(show);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            show(entry.target);
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -5% 0px',
        }
      );
    }

    elements.forEach((element) => observer.observe(element));
  };

  if (!prefersReducedMotion.matches && 'IntersectionObserver' in window) {
    document.documentElement.classList.add('rotar-site-motion-ready');
  }

  prepare();

  document.addEventListener('shopify:section:load', (event) => {
    prepare(event.target);
  });

  prefersReducedMotion.addEventListener?.('change', (event) => {
    if (!event.matches) return;
    observer?.disconnect();
    observer = undefined;
    document.documentElement.classList.remove('rotar-site-motion-ready');
    document.querySelectorAll(selector).forEach(show);
  });
})();
